module.exports = __webpack_public_path__ + "static/img/sm_21.3e2cea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_21.png
// module id = ObmT
// module chunks = 0